import React from 'react'

import ReactWhatsapp from "react-whatsapp";
import Breakfasts from "../images/breakf.jpg";
import chinese from "../images/chineese.jpg";
import indian_special from "../images/indianspecial.jpg";
import thali from "../images/khanre bangali.jpg";

import tandooriroti from "../images/tandoor roti.jpg"
import special_thali from "../images/thaliphoto.jpg"

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'








function Foodphoto() {
    return (
        <div>

          
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={Breakfasts} className="card-img-top" alt="Breakfasts"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Break Fast </h5>
            
                                              

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2 mt-2' href='tel: 9609612912'> Book Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={chinese} className="card-img-top" alt="chinese"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Chinese</h5>
                                        <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2 mt-2' href='tel: 9609612912'> Book Now</a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={indian_special} className="card-img-top" alt="indian_special"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Indian Special </h5>
          
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2 mt-2' href='tel: 9609612912'> Book Now</a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={thali} className="card-img-top" alt="thali"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Thali          </h5>
        
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2 mt-2' href='tel: 9609612912'> Book Now</a>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
              <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={tandooriroti} className="card-img-top" alt="tandooriroti"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Tandoori </h5>
            
                                              

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2 mt-2' href='tel: 9609612912'> Book Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={special_thali} className="card-img-top" alt="special_thali"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Special Thali</h5>
                                        <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2 mt-2' href='tel: 9609612912'> Book Now</a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                     

                    </div>
                </div>
            </div>


            <br />
        </div>
    )
}

export default Foodphoto